/* DecantGems: small progressive enhancements. Everything works without this file. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* country and language selects, sort and the collection filters submit on change; a select changed from the
     keyboard (arrow keys fire "change" at once on Windows) waits for Enter, or for leaving the field (a11y-13, WCAG 3.2.2) */
  var dgKbSelect = null;
  document.addEventListener('keydown', function (event) {
    var el = event.target;
    if (!el || el.tagName !== 'SELECT' || !el.form) return;
    if (!(el.matches('[data-dg-autosubmit]') || el.form.matches('[data-dg-autosubmit-form]'))) return;
    if (event.key === 'Enter') { if (el.dataset.dgDirty === '1') { event.preventDefault(); el.dataset.dgDirty = ''; el.form.submit(); } return; }
    if (event.key !== 'Tab') { dgKbSelect = el; }
  }, true);
  document.addEventListener('focusout', function (event) {
    var el = event.target;
    if (el && el.dataset && el.dataset.dgDirty === '1' && el.form) { el.dataset.dgDirty = ''; el.form.submit(); }
  }, true);
  document.addEventListener('pointerdown', function () { dgKbSelect = null; }, true);
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.matches || !el.form) return;
    if (el.matches('[data-dg-autosubmit]') || el.form.matches('[data-dg-autosubmit-form]')) {
      if (el.type === 'number') return; /* price fields: wait for Enter or the Apply button */
      var sheet = el.closest('[data-dg-fsheet]');
      if (sheet && sheet.dataset.dgModal === '1') return; /* phone filter sheet: wait for "Show perfumes" */
      if (el.tagName === 'SELECT' && dgKbSelect === el) { el.dataset.dgDirty = '1'; return; }
      el.form.submit();
    }
  });

  /* collection filters: "show all" in a long list */
  document.addEventListener('click', function (event) {
    var more = event.target.closest && event.target.closest('[data-dg-facet-more]');
    if (!more) return;
    var group = more.closest('.dg-facet');
    if (group) group.classList.add('dg-facet--all');
  });

  /* collection filters on phones: the groups open as a sheet (a modal dialog) from one "Filter" button */
  function initFacetSheet() {
    var sheet = document.querySelector('[data-dg-fsheet]');
    var opener = document.querySelector('[data-dg-fsheet-open]');
    if (!sheet || !opener || typeof sheet.showModal !== 'function' || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 749px)');
    function unlock() { document.documentElement.classList.remove('dg-lock'); sheet.dataset.dgModal = '0'; }
    function sync() {
      if (phone.matches) {
        if (sheet.dataset.dgModal !== '1') sheet.removeAttribute('open');
      } else {
        if (sheet.dataset.dgModal === '1') sheet.close();
        unlock();
        sheet.setAttribute('open', '');
      }
    }
    sync();
    if (phone.addEventListener) phone.addEventListener('change', sync);
    opener.addEventListener('click', function () {
      if (!phone.matches) return;
      sheet.removeAttribute('open');
      sheet.showModal();
      sheet.dataset.dgModal = '1';
      document.documentElement.classList.add('dg-lock');
    });
    sheet.addEventListener('close', function () { unlock(); opener.focus(); });
    sheet.addEventListener('click', function (event) {
      if (sheet.dataset.dgModal !== '1') return;
      if (event.target === sheet || (event.target.closest && event.target.closest('[data-dg-fsheet-close]'))) sheet.close();
    });
  }
  /* cookie banner: the sentence is clamped to two lines on phones, a tap opens it in full */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest || t.closest('a')) return;
    var p = t.closest('#shopify-pc__banner p');
    if (p) p.closest('#shopify-pc__banner').classList.toggle('dg-open');
  });

  /* article figures: a photo that does not load takes its figure with it (no broken image, the text stays) */
  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.closest) return;
    var fig = img.closest('.dg-fig');
    if (fig) fig.classList.add('dg-fig--gone');
  }, true);

  /* "read more" for clamped text: the button shows only when the text is really cut */
  /* one rAF-throttled, passive resize listener for everything in this file (no layout work inside the event itself) */
  var resizeFns = [];
  var resizeQueued = false;
  function onResize(fn) {
    if (!resizeFns.length) {
      window.addEventListener('resize', function () {
        if (resizeQueued) return;
        resizeQueued = true;
        window.requestAnimationFrame(function () {
          resizeQueued = false;
          resizeFns.forEach(function (f) { f(); });
        });
      }, { passive: true });
    }
    resizeFns.push(fn);
  }

  var clamps = [];
  /* read every clamp's heights first, then write the buttons: one layout instead of one per clamp */
  function checkClamps() {
    var open = clamps.filter(function (c) { return !c.el.classList.contains('dg-open'); });
    var over = open.map(function (c) { return c.el.scrollHeight > c.el.clientHeight + 6; });
    open.forEach(function (c, i) { c.btn.hidden = !over[i]; });
  }
  function initClamp(scope) {
    var added = false;
    (scope || document).querySelectorAll('[data-dg-clamp]').forEach(function (el) {
      var btn = el.parentNode.querySelector('[data-dg-more]');
      if (!btn || btn.dataset.dgReady) return;
      btn.dataset.dgReady = '1';
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('dg-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
      clamps.push({ el: el, btn: btn });
      added = true;
    });
    if (!added) return;
    if (clamps.length && !initClamp.bound) { initClamp.bound = true; onResize(checkClamps); }
    checkClamps();
  }

  /* close an open filter panel when another opens or on a click outside */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.dg-facet[open]').forEach(function (d) {
      if (!d.contains(event.target)) d.removeAttribute('open');
    });
  });

  /* rails: previous and next buttons, hidden when everything fits */
  function initRail(wrap) {
    var rail = wrap.querySelector('[data-dg-rail-track]');
    var nav = wrap.querySelector('[data-dg-rail-nav]') || document.querySelector('[data-dg-rail-nav="' + wrap.id + '"]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-dg-rail-prev]');
    var next = nav.querySelector('[data-dg-rail-next]');
    if (!prev || !next) return;

    function step() {
      var item = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      var size = item ? item.getBoundingClientRect().width + gap : rail.clientWidth;
      return Math.max(size, Math.floor(rail.clientWidth / size) * size);
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      nav.hidden = max <= 4;
      prev.disabled = rail.scrollLeft <= 4;
      next.disabled = rail.scrollLeft >= max - 4;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    /* the observer's first callback (after the browser's own layout) sets the arrows; no layout forced at start-up */
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
    else update();
  }

  /* product gallery: one sideways track of photos (it swipes by itself); thumbnails and arrow keys move it,
     a click on a photo opens it large in a dialog */
  function initGallery(root) {
    var track = root.querySelector('[data-dg-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dg-gallery-thumb]'));
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    function mark(i) {
      index = i;
      thumbs.forEach(function (b, n) { b.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var t = thumbs[i];
      var list = t && t.closest('.dg-pdp__thumbs');
      if (!list) return;
      /* keep the current thumbnail inside its own strip, without moving the page */
      var li = t.parentNode;
      if (li.offsetLeft < list.scrollLeft) list.scrollLeft = li.offsetLeft;
      else if (li.offsetLeft + li.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = li.offsetLeft + li.offsetWidth - list.clientWidth;
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
    }
    function go(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !calm ? 'smooth' : 'auto' });
      mark(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== index && slides[i]) mark(i);
      });
    }, { passive: true });
    thumbs.forEach(function (btn, n) {
      btn.addEventListener('click', function (event) { event.preventDefault(); go(n, true); });
    });
    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(index - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); go(index + 1, true); }
    });
    onResize(function () { track.scrollLeft = index * track.clientWidth; });

    var zoom = root.querySelector('[data-dg-zoom]');
    if (!zoom || typeof zoom.showModal !== 'function') return;
    var big = zoom.querySelector('[data-dg-zoom-img]');
    var opener = null;
    function fill() {
      var btn = slides[index] && slides[index].querySelector('[data-dg-zoom-open]');
      var img = btn && btn.querySelector('img');
      if (!btn) return;
      big.src = btn.getAttribute('data-zoom') || (img && (img.currentSrc || img.src)) || '';
      big.alt = img ? img.alt : '';
    }
    function step(d) { go(index + d, false); fill(); }
    track.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-dg-zoom-open]');
      if (!btn) return;
      var n = slides.indexOf(btn.closest('.dg-pdp__slide'));
      if (n > -1) mark(n);
      opener = btn;
      fill();
      zoom.showModal();
      document.documentElement.classList.add('dg-lock');
    });
    zoom.addEventListener('close', function () {
      document.documentElement.classList.remove('dg-lock');
      var back = slides[index] && slides[index].querySelector('[data-dg-zoom-open]');
      if (back || opener) (back || opener).focus({ preventScroll: true });
    });
    zoom.addEventListener('click', function (event) {
      var t = event.target;
      if (t.closest('[data-dg-zoom-prev]')) step(-1);
      else if (t.closest('[data-dg-zoom-next]')) step(1);
      else zoom.close(); /* the photo itself, the close button or the empty space */
    });
    zoom.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
  }

  /* reveal on scroll: only elements that start below the fold are hidden, and only once this script runs */
  function initReveal(scope) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dg-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    /* fix4-perf: no getBoundingClientRect per element (that forced one layout per element, up to 75 on home): a probe
       observer reports every element's position in one go; what is in, or within 30 % below, the first screen (or above it
       after a scroll restore) is never hidden */
    var probe = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        probe.unobserve(entry.target);
        /* rootBounds = the first screen + 30 % (no window.innerHeight read: that forced the page's first layout inside this script) */
        if (entry.isIntersecting || entry.boundingClientRect.top < (entry.rootBounds ? entry.rootBounds.bottom : 0)) return;
        entry.target.classList.add('dg-reveal');
        io.observe(entry.target);
      });
    }, { rootMargin: '0px 0px 30% 0px', threshold: 0 });
    (scope || document).querySelectorAll('[data-dg-reveal]:not(.dg-reveal)').forEach(function (el) { probe.observe(el); });
  }

  /* phone product page: the bar with one button shows whenever the buy / notify block is out of view
     (before the visitor reaches it and after scrolling past it) */
  function initStickybar() {
    var bar = document.querySelector('[data-dg-stickybar]');
    var buy = document.getElementById('DgBuy');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    if (buy.querySelector('.dg-form__ok')) return; /* the form has just been sent */
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      bar.classList.toggle('dg-on', !e.isIntersecting);
    }, { rootMargin: '-70px 0px -60px 0px', threshold: 0 }).observe(buy);
    var go = bar.querySelector('[data-dg-stickybar-go]');
    if (!go) return;
    go.addEventListener('click', function (event) {
      event.preventDefault();
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      buy.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'center' });
      var field = buy.querySelector('input[type="email"]');
      if (field) field.focus({ preventScroll: true });
    });
  }

  /* recently viewed: product handles in the visitor's own browser, only with consent for preferences */
  var RECENT_KEY = 'dg:recent';
  function withConsent(fn) {
    var S = window.Shopify;
    function allowed() {
      try { return !!(S.customerPrivacy && S.customerPrivacy.preferencesProcessingAllowed()); } catch (e) { return false; }
    }
    if (S && S.customerPrivacy) { fn(allowed()); return; }
    if (S && typeof S.loadFeatures === 'function') {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { fn(!error && allowed()); });
      return;
    }
    fn(false);
  }
  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function writeRecent(list) {
    try { window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 9))); } catch (e) {}
  }
  function fillRecent(box, list) {
    var track = box.querySelector('[data-dg-recent-list]');
    if (!track || box.dataset.dgFilled) return;
    var current = box.getAttribute('data-current');
    var handles = list.filter(function (h) { return h !== current; }).slice(0, 8);
    if (!handles.length) return;
    box.dataset.dgFilled = '1';
    var root = box.getAttribute('data-root') || '/';
    if (root.slice(-1) !== '/') root += '/';
    Promise.all(handles.map(function (handle) {
      return fetch(root + 'products/' + encodeURIComponent(handle) + '?section_id=dg-recent-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return null; });
    })).then(function (parts) {
      var gone = [];
      parts.forEach(function (html, i) {
        if (html === null) return; /* network trouble: keep the handle, show nothing for it */
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var item = tmp.querySelector('[data-dg-recent-item]');
        if (item) track.appendChild(item);
        else gone.push(handles[i]); /* the product no longer exists */
      });
      if (gone.length) writeRecent(readRecent().filter(function (h) { return gone.indexOf(h) === -1; }));
      if (!track.children.length) return;
      box.classList.add('dg-on');
      var rail = box.querySelector('[data-dg-rail]');
      if (rail) initRail(rail);
    });
  }
  function initRecent() {
    var here = document.querySelector('[data-dg-product]');
    var boxes = document.querySelectorAll('[data-dg-recent]');
    if (!here && !boxes.length) return;
    function run(ok) {
      if (!ok) return;
      var list = readRecent();
      boxes.forEach(function (box) { fillRecent(box, list); });
      if (here) {
        var handle = here.getAttribute('data-dg-product');
        if (handle) writeRecent([handle].concat(list.filter(function (h) { return h !== handle; })));
      }
    }
    withConsent(run);
    /* the visitor answers the cookie banner on this page: start, or forget what was kept */
    document.addEventListener('visitorConsentCollected', function (event) {
      var d = event.detail || {};
      if (d.preferencesAllowed) run(true);
      else { try { window.localStorage.removeItem(RECENT_KEY); } catch (e) {} }
    });
  }

  /* mobile menu: one group open at a time per level (also where <details name> is not supported) */
  document.addEventListener('toggle', function (event) {
    var d = event.target;
    if (!d || !d.open || !d.classList || !d.classList.contains('dg-dnav__group')) return;
    var item = d.parentNode;
    var list = item && item.parentNode;
    if (!list) return;
    Array.prototype.forEach.call(list.children, function (li) {
      if (li === item) return;
      var other = li.querySelector(':scope > .dg-dnav__group[open]');
      if (other) other.removeAttribute('open');
    });
  }, true);

  /* footer link columns: accordions on phones, always open on wider screens */
  function initFooterAcc() {
    var list = document.querySelectorAll('[data-dg-footer-acc]');
    if (!list.length || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 749px)');
    function apply() {
      list.forEach(function (d) {
        if (phone.matches) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
    }
    apply();
    if (phone.addEventListener) phone.addEventListener('change', apply);
  }

  ready(function () {
    initStickybar();
    initFooterAcc();
    initFacetSheet();
    if ('requestIdleCallback' in window) window.requestIdleCallback(initRecent, { timeout: 2500 });
    else window.setTimeout(initRecent, 800);
    initReveal(document);
    document.querySelectorAll('[data-dg-rail]').forEach(initRail);
    document.querySelectorAll('[data-dg-gallery]').forEach(initGallery);
    initClamp(document);
  });

  /* theme editor: sections can be re-rendered */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-dg-rail]').forEach(initRail);
    event.target.querySelectorAll('[data-dg-gallery]').forEach(initGallery);
    initClamp(event.target);
  });
})();

/* The .eu -> .nl/.de first-visit redirect lives inline at the top of <head> in layout/theme.liquid (.eu only). */
